import { OrganizationMaterialSet } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { getLoggedInUserOrganization } from '@paragon/login-tools';
import { enqueueError } from '@paragon/notification-tools';

import {
  appendSecondaryMaterialSet,
  clearMaterialLists,
  initiateOrganizationMaterialSetRequest,
  setMaterialListsError,
  setOrganizationMaterialSet,
} from '../store/materialListsSlice';
import { AsyncThunkActionVoid } from './thunkActions';

let onOrganizationMaterialSetLoaded: () => void;
export const whenOrganizationMaterialSetLoaded = new Promise<void>((resolve) => {
  onOrganizationMaterialSetLoaded = resolve;
});

export const loadCurrentOrganizationMaterialSet = (): AsyncThunkActionVoid => async (dispatch, getState) => {
  try {
    const organization = getLoggedInUserOrganization(getState());
    if (organization == null) {
      dispatch(clearMaterialLists());
      return;
    }
    const requestGuid = crypto.randomUUID();
    dispatch(initiateOrganizationMaterialSetRequest(requestGuid));
    const isRequestActive = () => {
      const materialListsState = getState().materialLists;
      return (
        materialListsState && materialListsState.state === 'loading' && materialListsState.requestGuid === requestGuid
      );
    };
    try {
      const materialSet = await designService.materialLists.getOrganizationMaterialSet(organization);
      if (isRequestActive()) {
        dispatch(setOrganizationMaterialSet(materialSet));
        return;
      }
    } catch (error) {
      if (isRequestActive()) {
        dispatch(setMaterialListsError());
        dispatch(enqueueError('Error loading material lists.'));
      }
    }
  } finally {
    onOrganizationMaterialSetLoaded();
  }
};

export function updateAlreadyLoadedOrganizationMaterialSet(set: OrganizationMaterialSet) {
  return setOrganizationMaterialSet(set);
}

export const loadSecondaryOrganizationMaterialSet =
  (organization: string): AsyncThunkActionVoid =>
  async (dispatch) => {
    dispatch(appendSecondaryMaterialSet(await designService.materialLists.getOrganizationMaterialSet(organization)));
  };
